export class DisplayModel {
    name: string;
    order: number;
    description: string;
    prefix: string;
    suffix: string;
}
